import { useEffect, useState } from "react";
import Moment from 'moment';
import { format } from "date-fns";


function VisitCounter(props) {
  const [visits, setVisits] = useState(0);
  const [visits2, setVisits2] = useState(0);

  // Loading from localStorage
  useEffect(() => {
    
    var now = new Date()
    var month = props.name + format(now, "MM");
    var day = props.name + format(now, "MM-dd");

    const storedVisits = Number(localStorage.getItem(month)) || 0;
    
    
    setVisits(storedVisits + 1);
    const storedVisits2 = Number(localStorage.getItem(day)) || 0;
    setVisits2(storedVisits2 + 1);
  }, []);

  // Saving in localStorage
  useEffect(() => {

    var now = new Date()
    var month = props.name + format(now, "MM");
    var day = props.name + format(now, "MM-dd");

    localStorage.setItem(month, visits);
    localStorage.setItem(day, visits2);
  }, [visits,visits2]);

  return(
    <div>
        <p></p>
        <p>Month : {visits}</p>
        <p>Day : {visits2}</p>
    </div>
    
    );
}



export {VisitCounter}
